import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tradesperson-scraper-display',
  templateUrl: './tradesperson-scraper-display.component.html',
  styleUrls: ['./tradesperson-scraper-display.component.scss']
})
export class TradespersonScraperDisplayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
